import { TableContainer, Paper, Table } from "@material-ui/core";
import classes from './index.module.css'
import { useState } from "react";

type Ord = 'asc' | 'desc';
type Props = {
  Thead: any
  Tbody: any
  Pagination?: any
  defaultOrderBy?: string
}
export type TheadProps = {
  onSort:(event: React.MouseEvent<unknown>,property: any) => void
  order: Ord
  orderBy: string
}

export interface HeadCell<Data> {
  id: keyof Data;
  label: string;
  format?: (row: any) => JSX.Element
  align?: "center" | "left" | "right"
}

export type TbodyProps = {
  onSort:(event: React.MouseEvent<unknown>,property: any) => void
  order: Ord
  orderBy: string
}

function SimpleTable<D>({Thead,Tbody,Pagination,defaultOrderBy}: Props) {
  const [order, setOrder] = useState<Ord>('desc');
  const [orderBy, setOrderBy] = useState<string>(defaultOrderBy || 'id');

  const changeSort = (
    event: React.MouseEvent<unknown>,
    property: string
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return ( 
    <div className={classes.root}>
      <TableContainer>
        <Table
          className={classes.table}
          size={'medium'}
        >
          <Thead onSort={changeSort} order={order} orderBy={orderBy}/>
          <Tbody onSort={changeSort} order={order} orderBy={orderBy}/>
        </Table>
      </TableContainer>
    </div>
  );
}

export default SimpleTable;